import type { ApiErrorParams } from '@/lib/api/client'

import { m } from '@/lib/paraglide/messages'

// Câu cụ thể cho PRODUCT_IMAGE_DESIGN_FIELD_INVALID / CERTIFICATION_BADGE_FIELD_INVALID
// theo (field, reason) — cùng câu với lỗi kiểm ở form (luật khớp server:
// usecase/productimagedesign/config.go, badges.go).

const str = (v: unknown) => (v == null ? '' : String(v))

export function designFieldMessage(params: ApiErrorParams): string {
    const field = str(params.field)
    const reason = str(params.reason)
    const max = str(params.max)
    const long = reason === 'too_long'
    switch (field) {
        case 'name':
            return long
                ? m.imgDesign_err_name_long({ max })
                : m.imgDesign_err_name_required()
        case 'tagline':
            return m.imgDesign_err_tagline_long({ max })
        case 'tagline2':
            return m.imgDesign_err_tagline2_long({ max })
        case 'region':
            return m.imgDesign_err_region_long({ max })
        case 'weight':
            return long
                ? m.imgDesign_err_weight_long({ max })
                : m.imgDesign_err_weight_required()
        case 'badge_ids':
            return m.imgDesign_err_badges_many({ max: max || '4' })
        case 'cutout_image_url':
        case 'original_image_url':
            return m.imgDesign_err_cutout_missing()
    }
    return m.error_product_image_design_field({ field, reason })
}

export function badgeFieldMessage(params: ApiErrorParams): string {
    const max = str(params.max)
    if (params.field === 'name')
        return params.reason === 'too_long'
            ? m.certBadge_err_name_long({ max })
            : m.certBadge_err_name_required()
    return m.error_certification_badge_field({
        field: str(params.field),
        reason: str(params.reason),
    })
}
